export const config = {
    //MW Prod
    //apiUrl: 'https://209.235.204.186:50166'
    //  apiUrl: 'https://api.microkeyvault.com'

    //MW UAT
    //apiUrl: 'http://72.240.44.163:50166'
    apiUrl: 'https://uatapi.microkeyvault.com'

    //my local
    // apiUrl: 'http://192.168.1.102:50166'
    //    apiUrl: 'http://192.168.1.181:50200'
    
};


// WEBPACK FOOTER //
// ./src/libs/config.js